import { Injectable } from '@angular/core';

import { BehaviorSubject, EMPTY, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsDataService {
  private readonly _notificationsCounter$ = new BehaviorSubject<number | null>(
    null
  );
  public readonly notificationsCounter$: Observable<number | null> =
    this._notificationsCounter$.asObservable();
  public readonly refresh$ = new Subject<void>();

  public setCounter(value: number | null): void {
    this._notificationsCounter$.next(value);
  }
}
